import { render, staticRenderFns } from "./ConfirmCampanhaNaoVigenteModal.vue?vue&type=template&id=5b2607aa&scoped=true&"
import script from "./ConfirmCampanhaNaoVigenteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmCampanhaNaoVigenteModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCampanhaNaoVigenteModal.vue?vue&type=style&index=0&id=5b2607aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2607aa",
  null
  
)

export default component.exports